import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

/* Importing the routes from the routes.js file. */
import Router from './routes';

/* Importing the theme provider from the theme.js file. */
import ThemeProvider from './theme';

/* ScrollToTop is a component that scrolls to the top of the page when the user navigates to a new
page.
BaseOptionChartStyle is a component that styles the charts. */
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

/* Exporting the App component. */
export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider>
        <ScrollToTop />
        <BaseOptionChartStyle />
        <Router />
      </ThemeProvider>
    </LocalizationProvider>
  );
}
